define("checkout/components/seamless-checkout/checkout-variant-modal", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "later/config/environment", "later/utils/load-script", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _tracking, _environment, _loadScript, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _trackCloseCheckout, _trackSelectedPlan;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"later/config/environment",0,"later/utils/load-script",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Containers::LoadCheckoutData
    @isVariant={{true}}
    @onTransactionComplete={{this.handleTransactionComplete}}
    @planType={{this.selectedPlanType}}
    as |checkout checkoutActions proration|
  >
    <Shared::Modal
      @closable={{and (not checkout.isLoading) this.canCloseModal}}
      @close={{fn this.closeCheckoutModal (or checkout.hasUnsavedCheckoutChanges this.hasAddressChanges)}}
      @closeButtonQaClass="qa--seamless__closeIcon"
      @focusTrap={{true}}
      class={{if this.isSeamlessCheckoutInProgress "is--disabled" ""}}
      as |modal|
    >
      <modal.card @portrait={{true}} class="tPF--variantCard qa--seamlessCheckout">
        {{#unless checkout.isLoading}}
          <modal.card-body class="{{concat 'tCH--plan--' this.selectedPlanType}} tPF--variant">
            {{! 1. Heading }}
            <header class="tPF--variant__header">
              <h2 class="tCK--title qa--seamless_title">
                {{t "plans.checkout.variant.title_trial_lead"}}
                <Shared::Ui::Button
                  @onClick={{toggle-action "showAllFeaturesModal" this}}
                  @variant="unstyled"
                  class="tPF--variant__planLink qa--seamless__planLink"
                >
                  {{t "plans.checkout.variant.plan_link" planName=checkout.planName}}
                  {{svg-jar "info" class="o--icon tPF--variant__planLinkIcon"}}
                </Shared::Ui::Button>
              </h2>
              <p class="tPF--variant__subtitle">
                {{t
                  "plans.checkout.variant.subtitle_trial"
                  amount=(format-currency checkout.selectedSubscriptionPlan.amount)
                  interval=checkout.selectedSubscriptionPlan.normalizedInterval
                }}
              </p>
            </header>
  
            {{! 2. Interval picker }}
            <Interval
              @displayMonthly={{this.canSelectMonthlyInterval}}
              @isHorizontal={{true}}
              @monthlyLabel={{t "plans.checkout.variant.interval_monthly"}}
              @monthlyPlan={{checkout.monthlyPlan}}
              @onInterval={{checkoutActions.handleInterval}}
              @selectedSubscriptionPlan={{checkout.selectedSubscriptionPlan}}
              @yearlyLabel={{t "plans.checkout.variant.interval_yearly"}}
              @yearlyPlan={{checkout.yearlyPlan}}
            />
  
            {{! 3. Payment method (Stripe wallets — Apple/Google Pay — included automatically) }}
            <Payment::PaymentMethod
              @hasActiveSubscription={{checkout.hasActiveSubscription}}
              @isDisabled={{this.isSeamlessCheckoutInProgress}}
              @label={{t "plans.checkout.variant.payment_method_label"}}
              @onStripePaymentElementChange={{checkoutActions.handleStripePaymentElementChange}}
              @onStripePaymentElementSaved={{checkoutActions.handleStripePaymentElementSaved}}
              @paymentMethod={{checkout.stripeCard}}
              @planType={{this.selectedPlanType}}
            />
  
            {{! 4. Mailing address }}
            <Payment::Address
              @hideEditingAddress={{this.hideEditingAddress}}
              @isDisabled={{this.isSeamlessCheckoutInProgress}}
              @isEditingAddress={{this.isEditingAddress}}
              @setEditingAddress={{this.setEditingAddress}}
            />
  
            {{! 5. Tax id + coupon — progressive-disclosure links (variant chrome) }}
            <Payment::TaxId
              @asLinkToggle={{true}}
              @collapsedText={{t "checkout.tax.variant.add_vat"}}
              @confirmText={{t "checkout.tax.variant.confirm_valid"}}
              @hasTaxId={{checkout.hasTaxId}}
              @taxIdChangeset={{checkout.taxIdChangeset}}
              @taxIdData={{checkout.taxIdData}}
              @validateTaxId={{checkoutActions.validateTaxId}}
            />
  
            <Payment::Coupon
              @asLinkToggle={{true}}
              @collapsedText={{t "plans.checkout.variant.coupon_prompt"}}
              @isDisabled={{this.isSeamlessCheckoutInProgress}}
              @isVisible={{checkout.canShowCouponForm}}
              @onCoupon={{checkoutActions.handleCoupon}}
              @selectedSubscriptionPlan={{checkout.selectedSubscriptionPlan}}
            />
  
            {{! 6. Slim trial summary (totals + tax line + Total Today + disclaimer) }}
            <section class="tCK--table tPF--variant__summary">
              <hr class="tCK--table__divider u--m__tb__sm" />
              {{! Coupon }}
              {{#if (and checkout.canApplyDiscount checkout.discountAmount)}}
                <div class="tCK--table__row u--m__b__md qa--couponLine_seamlessCheckout">
                  <div class="tCK--table__data">
                    <span class="u--text--bold" data-test-id="coupon">
                      {{t
                        "plans.checkout.plan.line_item_coupon"
                        description=(this.couponDescription checkout.coupon checkout.discount)
                      }}
                    </span>
                  </div>
                  <div class="tCK--table__data u--flex__justify--end">
                    <span data-test-id="coupon-cost">{{concat "-" (format-currency checkout.discountAmount)}}</span>
                  </div>
                </div>
              {{/if}}
              <SeamlessCheckoutTable::Charges
                @currentSubscriptionPlan={{checkout.currentSubscriptionPlan}}
                @discountAmount={{checkout.discountAmount}}
                @hasActiveTrial={{checkout.hasActiveTrial}}
                @hasCheckoutChanges={{checkout.hasCheckoutChanges}}
                @hasEnteredValidTaxId={{checkout.hasEnteredValidTaxId}}
                @hasExpiringDiscount={{checkout.hasExpiringDiscount}}
                @isEligibleForTrial={{checkout.isEligibleForTrial}}
                @isMonthly={{checkout.isMonthly}}
                @isVariant={{true}}
                @proration={{proration}}
                @selectedSubscriptionPlan={{checkout.selectedSubscriptionPlan}}
                @taxIdData={{checkout.taxIdData}}
              />
              <hr class="tCK--table__divider u--m__tb__sm" />
            </section>
  
            {{! 7. Inline generic-error line (failed checkout) — opt-in yield, control unaffected }}
            {{#if checkout.checkoutError}}
              <p class="tPF--variant__error qa--checkout__error" role="alert">
                {{checkout.checkoutError}}
              </p>
            {{/if}}
  
            {{! 8. Trial banner — lavender info-card }}
            <div class="tPF--variant__banner qa--checkout__no_charge" role="note">
              <span aria-hidden="true" class="tPF--variant__bannerIcon">
                {{svg-jar "check" class="o--icon"}}
              </span>
              <div class="tPF--variant__bannerContent">
                <p class="tPF--variant__bannerTitle">
                  {{t
                    "plans.checkout.variant.trial_banner_title"
                    date=(moment-format (or checkout.currentAccount.trialExpiryMoment proration.futureDate) "M/D/YYYY")
                  }}
                </p>
                <p class="tPF--variant__bannerBody">
                  {{t
                    "plans.checkout.variant.trial_banner_body"
                    amount=(format-currency proration.futureAmount)
                    date=(moment-format
                      (or checkout.currentAccount.trialExpiryMoment proration.futureDate) "MMM DD, YYYY"
                    )
                    interval=checkout.selectedSubscriptionPlan.intervalName
                    planName=checkout.planName
                  }}
                </p>
              </div>
            </div>
  
            {{! 9. CTA — renders "Start Free Trial" via existing trial button logic }}
            <CheckoutButton
              @hasActiveCancelledSubscription={{checkout.hasActiveCancelledSubscription}}
              @hasActiveSubscription={{checkout.hasActiveSubscription}}
              @hasActiveTrial={{checkout.hasActiveTrial}}
              @hasAddonChange={{checkout.hasAddonChange}}
              @hasCompleteAddress={{this.hasCompleteAddress}}
              @isEligibleForTrial={{checkout.isEligibleForTrial}}
              @isOnCardlessTrial={{checkout.isOnCardlessTrial}}
              @isPaymentMethodComplete={{checkout.isPaymentMethodComplete}}
              @isSameInterval={{checkout.isSameInterval}}
              @isSamePlan={{checkout.isSamePlan}}
              @onChangePlan={{checkoutActions.handleChangePlan}}
              @onCheckout={{checkoutActions.handleCheckout}}
              @savedStripeCard={{checkout.stripeCard}}
              @showMissingInfoMesage={{false}}
              @trialCheckoutText={{t "plans.checkout.variant.button_checkout_trial"}}
            />
  
            {{! 10. Security footer }}
            <div class="u--text--light u--p__t__sm qa--checkout__summary--secure tPF--variant__secure">
              {{svg-jar "lock" class="o--icon u--m__r__xs"}}
              {{t "plans.checkout.plan.summary_secure"}}
            </div>
          </modal.card-body>
        {{/unless}}
      </modal.card>
    </Shared::Modal>
  
    {{! Plan-name link → full feature comparison for the selected plan }}
    {{#if this.showAllFeaturesModal}}
      <Shared::Upgrade::AllFeaturesModal
        @close={{toggle-action "showAllFeaturesModal" this}}
        @focusTrap={{true}}
        @isMonthly={{checkout.isMonthly}}
        @planType={{this.selectedPlanType}}
      />
    {{/if}}
  </Containers::LoadCheckoutData>
  */
  {
    "id": "o1p0x1ai",
    "block": "[[[8,[39,0],null,[[\"@isVariant\",\"@onTransactionComplete\",\"@planType\"],[true,[30,0,[\"handleTransactionComplete\"]],[30,0,[\"selectedPlanType\"]]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[39,1],[[16,0,[52,[30,0,[\"isSeamlessCheckoutInProgress\"]],\"is--disabled\",\"\"]]],[[\"@closable\",\"@close\",\"@closeButtonQaClass\",\"@focusTrap\"],[[28,[37,3],[[28,[37,4],[[30,1,[\"isLoading\"]]],null],[30,0,[\"canCloseModal\"]]],null],[28,[37,5],[[30,0,[\"closeCheckoutModal\"]],[28,[37,6],[[30,1,[\"hasUnsavedCheckoutChanges\"]],[30,0,[\"hasAddressChanges\"]]],null]],null],\"qa--seamless__closeIcon\",true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,4,[\"card\"]],[[24,0,\"tPF--variantCard qa--seamlessCheckout\"]],[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n\"],[41,[51,[30,1,[\"isLoading\"]]],[[[1,\"        \"],[8,[30,4,[\"card-body\"]],[[16,0,[29,[[28,[37,8],[\"tCH--plan--\",[30,0,[\"selectedPlanType\"]]],null],\" tPF--variant\"]]]],null,[[\"default\"],[[[[1,\"\\n\"],[1,\"          \"],[10,\"header\"],[14,0,\"tPF--variant__header\"],[12],[1,\"\\n            \"],[10,\"h2\"],[14,0,\"tCK--title qa--seamless_title\"],[12],[1,\"\\n              \"],[1,[28,[35,9],[\"plans.checkout.variant.title_trial_lead\"],null]],[1,\"\\n              \"],[8,[39,10],[[24,0,\"tPF--variant__planLink qa--seamless__planLink\"]],[[\"@onClick\",\"@variant\"],[[28,[37,11],[\"showAllFeaturesModal\",[30,0]],null],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n                \"],[1,[28,[35,9],[\"plans.checkout.variant.plan_link\"],[[\"planName\"],[[30,1,[\"planName\"]]]]]],[1,\"\\n                \"],[1,[28,[35,12],[\"info\"],[[\"class\"],[\"o--icon tPF--variant__planLinkIcon\"]]]],[1,\"\\n              \"]],[]]]]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,2],[14,0,\"tPF--variant__subtitle\"],[12],[1,\"\\n              \"],[1,[28,[35,9],[\"plans.checkout.variant.subtitle_trial\"],[[\"amount\",\"interval\"],[[28,[37,13],[[30,1,[\"selectedSubscriptionPlan\",\"amount\"]]],null],[30,1,[\"selectedSubscriptionPlan\",\"normalizedInterval\"]]]]]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\\n\"],[1,\"          \"],[8,[39,14],null,[[\"@displayMonthly\",\"@isHorizontal\",\"@monthlyLabel\",\"@monthlyPlan\",\"@onInterval\",\"@selectedSubscriptionPlan\",\"@yearlyLabel\",\"@yearlyPlan\"],[[30,0,[\"canSelectMonthlyInterval\"]],true,[28,[37,9],[\"plans.checkout.variant.interval_monthly\"],null],[30,1,[\"monthlyPlan\"]],[30,2,[\"handleInterval\"]],[30,1,[\"selectedSubscriptionPlan\"]],[28,[37,9],[\"plans.checkout.variant.interval_yearly\"],null],[30,1,[\"yearlyPlan\"]]]],null],[1,\"\\n\\n\"],[1,\"          \"],[8,[39,15],null,[[\"@hasActiveSubscription\",\"@isDisabled\",\"@label\",\"@onStripePaymentElementChange\",\"@onStripePaymentElementSaved\",\"@paymentMethod\",\"@planType\"],[[30,1,[\"hasActiveSubscription\"]],[30,0,[\"isSeamlessCheckoutInProgress\"]],[28,[37,9],[\"plans.checkout.variant.payment_method_label\"],null],[30,2,[\"handleStripePaymentElementChange\"]],[30,2,[\"handleStripePaymentElementSaved\"]],[30,1,[\"stripeCard\"]],[30,0,[\"selectedPlanType\"]]]],null],[1,\"\\n\\n\"],[1,\"          \"],[8,[39,16],null,[[\"@hideEditingAddress\",\"@isDisabled\",\"@isEditingAddress\",\"@setEditingAddress\"],[[30,0,[\"hideEditingAddress\"]],[30,0,[\"isSeamlessCheckoutInProgress\"]],[30,0,[\"isEditingAddress\"]],[30,0,[\"setEditingAddress\"]]]],null],[1,\"\\n\\n\"],[1,\"          \"],[8,[39,17],null,[[\"@asLinkToggle\",\"@collapsedText\",\"@confirmText\",\"@hasTaxId\",\"@taxIdChangeset\",\"@taxIdData\",\"@validateTaxId\"],[true,[28,[37,9],[\"checkout.tax.variant.add_vat\"],null],[28,[37,9],[\"checkout.tax.variant.confirm_valid\"],null],[30,1,[\"hasTaxId\"]],[30,1,[\"taxIdChangeset\"]],[30,1,[\"taxIdData\"]],[30,2,[\"validateTaxId\"]]]],null],[1,\"\\n\\n          \"],[8,[39,18],null,[[\"@asLinkToggle\",\"@collapsedText\",\"@isDisabled\",\"@isVisible\",\"@onCoupon\",\"@selectedSubscriptionPlan\"],[true,[28,[37,9],[\"plans.checkout.variant.coupon_prompt\"],null],[30,0,[\"isSeamlessCheckoutInProgress\"]],[30,1,[\"canShowCouponForm\"]],[30,2,[\"handleCoupon\"]],[30,1,[\"selectedSubscriptionPlan\"]]]],null],[1,\"\\n\\n\"],[1,\"          \"],[10,\"section\"],[14,0,\"tCK--table tPF--variant__summary\"],[12],[1,\"\\n            \"],[10,\"hr\"],[14,0,\"tCK--table__divider u--m__tb__sm\"],[12],[13],[1,\"\\n\"],[41,[28,[37,3],[[30,1,[\"canApplyDiscount\"]],[30,1,[\"discountAmount\"]]],null],[[[1,\"              \"],[10,0],[14,0,\"tCK--table__row u--m__b__md qa--couponLine_seamlessCheckout\"],[12],[1,\"\\n                \"],[10,0],[14,0,\"tCK--table__data\"],[12],[1,\"\\n                  \"],[10,1],[14,0,\"u--text--bold\"],[14,\"data-test-id\",\"coupon\"],[12],[1,\"\\n                    \"],[1,[28,[35,9],[\"plans.checkout.plan.line_item_coupon\"],[[\"description\"],[[28,[30,0,[\"couponDescription\"]],[[30,1,[\"coupon\"]],[30,1,[\"discount\"]]],null]]]]],[1,\"\\n                  \"],[13],[1,\"\\n                \"],[13],[1,\"\\n                \"],[10,0],[14,0,\"tCK--table__data u--flex__justify--end\"],[12],[1,\"\\n                  \"],[10,1],[14,\"data-test-id\",\"coupon-cost\"],[12],[1,[28,[35,8],[\"-\",[28,[37,13],[[30,1,[\"discountAmount\"]]],null]],null]],[13],[1,\"\\n                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],null],[1,\"            \"],[8,[39,19],null,[[\"@currentSubscriptionPlan\",\"@discountAmount\",\"@hasActiveTrial\",\"@hasCheckoutChanges\",\"@hasEnteredValidTaxId\",\"@hasExpiringDiscount\",\"@isEligibleForTrial\",\"@isMonthly\",\"@isVariant\",\"@proration\",\"@selectedSubscriptionPlan\",\"@taxIdData\"],[[30,1,[\"currentSubscriptionPlan\"]],[30,1,[\"discountAmount\"]],[30,1,[\"hasActiveTrial\"]],[30,1,[\"hasCheckoutChanges\"]],[30,1,[\"hasEnteredValidTaxId\"]],[30,1,[\"hasExpiringDiscount\"]],[30,1,[\"isEligibleForTrial\"]],[30,1,[\"isMonthly\"]],true,[30,3],[30,1,[\"selectedSubscriptionPlan\"]],[30,1,[\"taxIdData\"]]]],null],[1,\"\\n            \"],[10,\"hr\"],[14,0,\"tCK--table__divider u--m__tb__sm\"],[12],[13],[1,\"\\n          \"],[13],[1,\"\\n\\n\"],[41,[30,1,[\"checkoutError\"]],[[[1,\"            \"],[10,2],[14,0,\"tPF--variant__error qa--checkout__error\"],[14,\"role\",\"alert\"],[12],[1,\"\\n              \"],[1,[30,1,[\"checkoutError\"]]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[1,\"          \"],[10,0],[14,0,\"tPF--variant__banner qa--checkout__no_charge\"],[14,\"role\",\"note\"],[12],[1,\"\\n            \"],[10,1],[14,\"aria-hidden\",\"true\"],[14,0,\"tPF--variant__bannerIcon\"],[12],[1,\"\\n              \"],[1,[28,[35,12],[\"check\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,0],[14,0,\"tPF--variant__bannerContent\"],[12],[1,\"\\n              \"],[10,2],[14,0,\"tPF--variant__bannerTitle\"],[12],[1,\"\\n                \"],[1,[28,[35,9],[\"plans.checkout.variant.trial_banner_title\"],[[\"date\"],[[28,[37,20],[[28,[37,6],[[30,1,[\"currentAccount\",\"trialExpiryMoment\"]],[30,3,[\"futureDate\"]]],null],\"M/D/YYYY\"],null]]]]],[1,\"\\n              \"],[13],[1,\"\\n              \"],[10,2],[14,0,\"tPF--variant__bannerBody\"],[12],[1,\"\\n                \"],[1,[28,[35,9],[\"plans.checkout.variant.trial_banner_body\"],[[\"amount\",\"date\",\"interval\",\"planName\"],[[28,[37,13],[[30,3,[\"futureAmount\"]]],null],[28,[37,20],[[28,[37,6],[[30,1,[\"currentAccount\",\"trialExpiryMoment\"]],[30,3,[\"futureDate\"]]],null],\"MMM DD, YYYY\"],null],[30,1,[\"selectedSubscriptionPlan\",\"intervalName\"]],[30,1,[\"planName\"]]]]]],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\\n\"],[1,\"          \"],[8,[39,21],null,[[\"@hasActiveCancelledSubscription\",\"@hasActiveSubscription\",\"@hasActiveTrial\",\"@hasAddonChange\",\"@hasCompleteAddress\",\"@isEligibleForTrial\",\"@isOnCardlessTrial\",\"@isPaymentMethodComplete\",\"@isSameInterval\",\"@isSamePlan\",\"@onChangePlan\",\"@onCheckout\",\"@savedStripeCard\",\"@showMissingInfoMesage\",\"@trialCheckoutText\"],[[30,1,[\"hasActiveCancelledSubscription\"]],[30,1,[\"hasActiveSubscription\"]],[30,1,[\"hasActiveTrial\"]],[30,1,[\"hasAddonChange\"]],[30,0,[\"hasCompleteAddress\"]],[30,1,[\"isEligibleForTrial\"]],[30,1,[\"isOnCardlessTrial\"]],[30,1,[\"isPaymentMethodComplete\"]],[30,1,[\"isSameInterval\"]],[30,1,[\"isSamePlan\"]],[30,2,[\"handleChangePlan\"]],[30,2,[\"handleCheckout\"]],[30,1,[\"stripeCard\"]],false,[28,[37,9],[\"plans.checkout.variant.button_checkout_trial\"],null]]],null],[1,\"\\n\\n\"],[1,\"          \"],[10,0],[14,0,\"u--text--light u--p__t__sm qa--checkout__summary--secure tPF--variant__secure\"],[12],[1,\"\\n            \"],[1,[28,[35,12],[\"lock\"],[[\"class\"],[\"o--icon u--m__r__xs\"]]]],[1,\"\\n            \"],[1,[28,[35,9],[\"plans.checkout.plan.summary_secure\"],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"    \"]],[]]]]],[1,\"\\n  \"]],[4]]]]],[1,\"\\n\\n\"],[41,[30,0,[\"showAllFeaturesModal\"]],[[[1,\"    \"],[8,[39,22],null,[[\"@close\",\"@focusTrap\",\"@isMonthly\",\"@planType\"],[[28,[37,11],[\"showAllFeaturesModal\",[30,0]],null],true,[30,1,[\"isMonthly\"]],[30,0,[\"selectedPlanType\"]]]],null],[1,\"\\n\"]],[]],null]],[1,2,3]]]]]],[\"checkout\",\"checkoutActions\",\"proration\",\"modal\"],false,[\"containers/load-checkout-data\",\"shared/modal\",\"if\",\"and\",\"not\",\"fn\",\"or\",\"unless\",\"concat\",\"t\",\"shared/ui/button\",\"toggle-action\",\"svg-jar\",\"format-currency\",\"interval\",\"payment/payment-method\",\"payment/address\",\"payment/tax-id\",\"payment/coupon\",\"seamless-checkout-table/charges\",\"moment-format\",\"checkout-button\",\"shared/upgrade/all-features-modal\"]]",
    "moduleName": "checkout/components/seamless-checkout/checkout-variant-modal.hbs",
    "isStrictMode": false
  });
  /**
   * The redesigned single-column checkout modal shown to free, trial-eligible accounts
   * on the free-trial-redesign experiment variant. Reuses the same building blocks as the
   * control `CheckoutModal` (via `Containers::LoadCheckoutData`) but reflows them into a
   * single column. The light getters/actions below are intentionally duplicated from
   * `checkout-modal.ts` so the control modal stays untouched.
   */
  let CheckoutVariantModalComponent = _exports.default = (_class = (_trackCloseCheckout = /*#__PURE__*/new WeakSet(), _trackSelectedPlan = /*#__PURE__*/new WeakSet(), class CheckoutVariantModalComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);

      // Note: Google script to load recaptcha for seamless checkout
      // https://developers.google.com/recaptcha/docs/v3
      _classPrivateMethodInitSpec(this, _trackSelectedPlan);
      _classPrivateMethodInitSpec(this, _trackCloseCheckout);
      _initializerDefineProperty(this, "address", _descriptor, this);
      _initializerDefineProperty(this, "dialogManager", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "plans", _descriptor4, this);
      _initializerDefineProperty(this, "seamlessCheckoutManager", _descriptor5, this);
      _initializerDefineProperty(this, "segment", _descriptor6, this);
      _initializerDefineProperty(this, "isEditingAddress", _descriptor7, this);
      _initializerDefineProperty(this, "showAllFeaturesModal", _descriptor8, this);
      (0, _loadScript.default)(`https://www.google.com/recaptcha/api.js?render=${_environment.default.APP.googleRecaptchaSiteKey}`);
      _classPrivateMethodGet(this, _trackSelectedPlan, _trackSelectedPlan2).call(this);
    }
    get selectedPlanType() {
      return this.seamlessCheckoutManager.selectedPlanType;
    }
    get canSelectMonthlyInterval() {
      return this.plans.canSelectMonthlyInterval;
    }
    get canCloseModal() {
      return !this.isSeamlessCheckoutInProgress && this.seamlessCheckoutManager.canCloseCheckoutModal;
    }
    get isSeamlessCheckoutInProgress() {
      return this.seamlessCheckoutManager.isCheckoutInProgress;
    }
    get hasCompleteAddress() {
      const requiresAddress = this.address.addressCollectionEnabled && this.address.isFullAddressRequired;
      if (!requiresAddress) {
        return true;
      }
      return this.address.isSavedAddressValid && !this.isEditingAddress && !this.address.hasUnsavedChanges;
    }
    get hasAddressChanges() {
      return this.address.hasUnsavedChanges;
    }
    couponDescription(coupon, discount) {
      if (!coupon) {
        return discount?.name ?? null;
      }
      const name = coupon.name || coupon.id;
      return coupon.percentOff ? `${name} ${coupon.percentOff}%` : `${name}`;
    }
    hideEditingAddress() {
      this.isEditingAddress = false;
    }
    setEditingAddress() {
      this.isEditingAddress = true;
    }
    handleTransactionComplete() {
      this.seamlessCheckoutManager.successCallback?.();
      if (this.seamlessCheckoutManager.shouldShowCheckoutSuccessModal) {
        this.seamlessCheckoutManager.openCheckoutSuccessModal();
      }
      this.seamlessCheckoutManager.successCallback = null;
    }
    async closeCheckoutModal() {
      let hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (this.seamlessCheckoutManager.isCheckoutInProgress) {
        return;
      }
      if (hasChanges) {
        const didConfirm = await this.dialogManager.confirmation(this.intl.t('shared_phrases.close_warning'), {
          description: this.intl.t('shared_phrases.your_changes_not_saved'),
          confirmButton: this.intl.t('shared_words.leave')
        });
        if (!didConfirm) {
          return;
        }
      }
      _classPrivateMethodGet(this, _trackCloseCheckout, _trackCloseCheckout2).call(this);
      this.seamlessCheckoutManager.closeCheckoutModal();
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "address", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "plans", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "seamlessCheckoutManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "isEditingAddress", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "showAllFeaturesModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "hideEditingAddress", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "hideEditingAddress"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setEditingAddress", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setEditingAddress"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleTransactionComplete", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleTransactionComplete"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeCheckoutModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeCheckoutModal"), _class.prototype)), _class);
  function _trackCloseCheckout2() {
    if (!this.selectedPlanType) {
      return;
    }
    this.segment.track(`closed-seamless-trial-checkout-${this.selectedPlanType}`);
  }
  function _trackSelectedPlan2() {
    if (!this.selectedPlanType) {
      return;
    }
    const page = this.seamlessCheckoutManager.location;
    this.segment.track('selected-plan-for-trial', {
      plan: this.selectedPlanType,
      page
    });
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, CheckoutVariantModalComponent);
});